type Props = {
  text: string;
};

export function AssistantPlanGuideline({ text }: Props) {
  if (!text.trim()) return null;
  return (
    <p className="text-sm leading-relaxed text-[#576274] dark:text-gray-300">{text}</p>
  );
}
